import gql from 'graphql-tag';

const mutation = gql`
  mutation SendNewMessageNotificationEmail($params: SendNewMessageNotificationEmailParams!) {
    sendNewMessageNotificationEmail(params: $params)
  }
`;

export default mutation;
